var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-25 -25 125 125",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 29.51,
    height: 29.51,
    rx: 5.83,
    ry: 5.83,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.48,
    y: 0.75,
    width: 29.51,
    height: 29.51,
    rx: 5.83,
    ry: 5.83,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 43.21,
    width: 29.51,
    height: 29.51,
    rx: 5.83,
    ry: 5.83,
    fill: "none",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.48,
    y: 43.21,
    width: 29.51,
    height: 29.51,
    rx: 5.83,
    ry: 5.83,
    fill: "none",
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtList);
export default __webpack_public_path__ + "static/media/bt_list.212ea72bc50aa5c31d4a8803d9e0655d.svg";
export { ForwardRef as ReactComponent };